import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Header } from "semantic-ui-react";
import logo from "../../assets/images/sherpa-logo-white-large.png";

class SentryHeader extends PureComponent {
  static propTypes = {
    testingEnvironment: PropTypes.string
  };

  render() {
    const { testingEnvironment } = this.props;

    return (
      <div className="sentry-header">
        <img src={logo} className="logo" />
        {testingEnvironment && (
          <Header as="h3" inverted textAlign="center">
            {testingEnvironment.toUpperCase()}
          </Header>
        )}
      </div>
    );
  }
}

export default SentryHeader;
